// In a utils file
import { useTranslation as useTranslationOriginal } from "react-i18next";
import { useCallback } from "react";

export const useTranslation = (namespace?: string) => {
  const [t, i18n] = useTranslationOriginal(namespace);

  const typedT = useCallback((key: string, options?: any): string => {
    return t(key, options);
  }, [t]);

  return [typedT, i18n] as const;
};
